// filter enum
export const filterEnum = {
  DATE: "date",
  BRANCH: "branch",
  STATUS: "status",
  CATEGORY: "category",
};

